import { render, staticRenderFns } from "./CampusUserNetworkSubnets.vue?vue&type=template&id=5fe3ce64&scoped=true&"
import script from "./CampusUserNetworkSubnets.vue?vue&type=script&lang=ts&"
export * from "./CampusUserNetworkSubnets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe3ce64",
  null
  
)

export default component.exports